import type { CaseStudyImage, CaseStudySection } from './amexCaseStudy';
export const mckinseyIntro = {
  client: 'McKinsey',
  title: 'Designing the pitch that won a $10M data transformation',
  summary: 'Showing Aon what its own data could do, before the data was ready.',
  background: 'linear-gradient(180deg, #E9F3F5 0%, #B7CED3 100%)',
};

export const mckinseyMetrics = [
  { value: '$10M+', label: 'contract value' },
  { value: '4 months', label: 'research & design project' },
  { value: '$12B+', label: 'revenue managed' },
];

export const mckinseySections: CaseStudySection[] = [
  {
    heading: "A client that couldn't see its own customers",
    paragraphs: [
      "Aon, a major multinational insurer, had highly fragmented data and couldn't see a complete picture of its own clients in one place. Fixing that would be a long, complex effort that needed funding. The pitch had to make the payoff concrete: showing what clean data pipelines could do for the business was what would unlock the money.",
    ],
  },
  {
    heading: 'Many decision-makers, scattered information',
    paragraphs: [
      'The client had many decision-makers, and the information we needed was spread across different places.',
    ],
  },
  {
    heading: 'Two decisions',
    bullets: [
      'I gave people something to react to. Even with incomplete information, showing visual artifacts helped the client understand what data we needed from them.',
      'I focused on storytelling, since the audience was non-technical executives who needed to see the value of data integration.',
    ],
  },
  {
    heading: 'Listening before designing',
    paragraphs: [
      'I interviewed many internal stakeholders to understand the full situation. I also collected samples of the reports and visualizations they were already using and treated them as inputs to the design.',
    ],
  },
  {
    heading: 'Prototype and result',
    paragraphs: [
      'I built a full prototype in Figma and later rebuilt it in Magic Patterns. The pitch won a data transformation project worth more than $10M, which deeply embedded McKinsey in the client organization.',
    ],
  },
];

export const mckinseyImages: CaseStudyImage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/sfKm3XHCbfkUsCcP1EwqNJ/01_Overview.jpg',
    alt: 'Client overview dashboard with relationship map, profile, closed opportunities, revenue data, and pipeline',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/83BXQZX3svvbFZTfRwHN5D/02_Profile.jpg',
    alt: 'Client profile with company overview, news, sales by segment, and market data',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ppfp7L3CL3jpUoTU9Bo7mY/03_Colleagues.jpg',
    alt: 'Colleagues table listing roles, business lines, and locations',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3RWoStWWgy2bxe24EyaRCx/04_Pipeline.jpg',
    alt: 'Client pipeline grouped by lead, won, open, and lost status',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ojBhJEmFZGY7kdhZkrDSWH/05_Metrics.jpg',
    alt: 'DAU metrics with an activity timeline, client planning, jeopardy management, and feedback',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4rTiL7hhivNt9fFKQnbeYu/06_Revenue.jpg',
    alt: 'Revenue grid by region and solution line',
  },
];
